export default {
  errorBrand: null,
  errorBrandCode: null,
  errorType: null,
  errorParentCode: null,
  errorIsSingleProduct: null,
  errorIsAnyStore: null,
  errorRedeemStartDate: null,
  errorRedeemEndDate: null,
  errorLimit: null,
  errorQuota: null,
  errorExpiryDate: null,
  errorNameTh: null,
  errorShortDescriptionTh: null,
  errorDescriptionTh: null,
  errorCategory: null,
  errorConditionTh: null,
  errorSampleProductDetailTh: null,
  errorSampleProductDetailEn: null,
  errorVoucherThumbnailImage: null,
  errorPrivilegeThumbnailImage: null,
  errorPoint: null,
  errorPointYear: null,
  errorExpiryDay: null,
  errorExpiryType: null,
  errorNameEn: null,
  errorPickupStores: null,
  errorPrivilegeType: null,
  errorIsAllowDelivery: null,
  errorDeliveryQuota: null,
  errorDeliveryLeadTimeInDay: null,
  errorIsAllowPickup: null,
  errorPickupCountersWithQuotaTempFile: null,
  errorPickupDateFrom: null,
  errorPickupDateTo: null,
  errorRewardType: null,
  errorRewardCategories: null,
  errorCampaignPurchaseCalculationStartDate: null,
  errorCampaignPurchaseCalculationEndDate: null,
  errorCampaignMinimumSpending: null,
  errorCampaignBanner: null,
  errorCampaignDetailTh: null,
  errorCampaignDetailEn: null,
};
